"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { FiEdit, FiEdit2 } from "react-icons/fi";
import { Button } from "@/components/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSoldByProviders } from "@/hooks/use-providers";
import { formatStaffName } from "@/lib/format-data";
import { ChargeItem } from "@/types/charge";
import { FirebaseProviderSummary } from "@/types/provider";
import { useChargeMutations } from "@/api/provider/billing/charge-query";
interface SoldByProviderDisplayProps {
  items?: ChargeItem[];
  readonly?: boolean;
  inline?: boolean;
}
interface SoldByProviderInfo {
  id: string;
  name: string;
  soldByProviderId?: string;
}
export default function SoldByProviderDisplay(t0) {
  const $ = _c(44);
  const {
    items,
    readonly: t1,
    inline: t2
  } = t0;
  const readonly = t1 === undefined ? false : t1;
  const inline = t2 === undefined ? false : t2;
  const [editingId, setEditingId] = useState(null);
  const [tempProviderId, setTempProviderId] = useState("");
  const [isInlineEditing, setIsInlineEditing] = useState(false);
  const [optimisticItems, setOptimisticItems] = useState(items);
  let t3;
  let t4;
  if ($[0] !== items) {
    t3 = () => {
      setOptimisticItems(items);
    };
    t4 = [items];
    $[0] = items;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  const {
    soldByProviders,
    providerIdProviderMap
  } = useSoldByProviders();
  let t5;
  if ($[3] !== providerIdProviderMap || $[4] !== soldByProviders) {
    t5 = currentId => {
      const current = providerIdProviderMap.get(currentId);
      const offered = soldByProviders.some(p => p.id === currentId);
      return <><SelectItem value="__unassigned__">Unassigned</SelectItem>{current && !offered && <SelectItem key={current.id} value={current.id} disabled={true}>{formatStaffName(current)}</SelectItem>}{soldByProviders.map(_temp)}</>;
    };
    $[3] = providerIdProviderMap;
    $[4] = soldByProviders;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const renderMenuItems = t5;
  const chargeMutations = useChargeMutations();
  const t6 = chargeMutations.updateSoldByProvider;
  let t7;
  if ($[6] !== chargeMutations.updateSoldByProvider || $[7] !== items) {
    t7 = variables => {
      chargeMutations.updateSoldByProvider.mutate({
        ...variables,
        itemType: "item"
      }, {
        onError: () => {
          setOptimisticItems(items);
        }
      });
    };
    $[6] = chargeMutations.updateSoldByProvider;
    $[7] = items;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t10;
  let t8;
  let t9;
  if ($[9] !== chargeMutations.updateSoldByProvider || $[10] !== editingId || $[11] !== inline || $[12] !== isInlineEditing || $[13] !== optimisticItems || $[14] !== providerIdProviderMap || $[15] !== readonly || $[16] !== renderMenuItems || $[17] !== t7 || $[18] !== tempProviderId) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const updateProviderMutation = {
        ...t6,
        mutate: t7
      };
      const itemsWithIds = (optimisticItems ?? []).filter(_temp2);
      const soldByProviderInfo = itemsWithIds.map(_temp3);
      let t11;
      if ($[22] !== providerIdProviderMap) {
        t11 = (acc, info) => {
          if (info.soldByProviderId) {
            const provider_0 = info.soldByProviderId ? providerIdProviderMap.get(info.soldByProviderId) : undefined;
            if (provider_0) {
              acc.assignedProviders.add(provider_0);
            }
          } else {
            acc.hasUnassigned = true;
          }
          return acc;
        };
        $[22] = providerIdProviderMap;
        $[23] = t11;
      } else {
        t11 = $[23];
      }
      const providerAnalysis = soldByProviderInfo.reduce(t11, {
        assignedProviders: new Set(),
        hasUnassigned: false
      });
      const uniqueProviders = Array.from(providerAnalysis.assignedProviders);
      const hasUnassignedItems = providerAnalysis.hasUnassigned;
      let t12;
      if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (id, currentProviderId) => {
          setEditingId(id);
          setTempProviderId(currentProviderId || "__unassigned__");
        };
        $[24] = t12;
      } else {
        t12 = $[24];
      }
      const handleEdit = t12;
      const handleProviderChange = (newProviderId, id_0) => {
        const providerId = newProviderId === "__unassigned__" ? null : newProviderId || null;
        setOptimisticItems(prev => prev?.map(item_0 => item_0.id === id_0 ? {
          ...item_0,
          soldByProviderId: providerId || undefined
        } : item_0) || []);
        updateProviderMutation.mutate({
          itemId: id_0,
          providerId
        });
        setEditingId(null);
        setTempProviderId("");
        setIsInlineEditing(false);
      };
      const handleInlineEdit = () => {
        setIsInlineEditing(true);
        if (soldByProviderInfo.length > 0) {
          setEditingId(soldByProviderInfo[0].id);
          setTempProviderId(soldByProviderInfo[0].soldByProviderId || "__unassigned__");
        }
      };
      if (soldByProviderInfo.length === 0) {
        t10 = null;
        break bb0;
      }
      if (readonly) {
        let t13;
        bb1: {
          if (uniqueProviders.length === 0) {
            let t14;
            if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
              t14 = <span className="text-foreground-muted">Unassigned</span>;
              $[25] = t14;
            } else {
              t14 = $[25];
            }
            t13 = t14;
            break bb1;
          }
          if (uniqueProviders.length === 1 && !hasUnassignedItems) {
            t13 = <span>{formatStaffName(uniqueProviders[0])}</span>;
            break bb1;
          }
          if (uniqueProviders.length === 1 && hasUnassignedItems) {
            let t14;
            if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
              t14 = <span className="text-foreground-muted">, Some unassigned</span>;
              $[26] = t14;
            } else {
              t14 = $[26];
            }
            t13 = <span>{formatStaffName(uniqueProviders[0])}{t14}</span>;
            break bb1;
          }
          t13 = <span className="text-foreground-muted">Multiple providers ({uniqueProviders.length})<span>{hasUnassignedItems && ", Some unassigned"}</span></span>;
        }
        const content = t13;
        if (inline) {
          if (!readonly && isInlineEditing && editingId) {
            let t14;
            if ($[27] !== editingId) {
              t14 = i_0 => i_0.id === editingId;
              $[27] = editingId;
              $[28] = t14;
            } else {
              t14 = $[28];
            }
            const editingInfo = soldByProviderInfo.find(t14);
            let t15;
            if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
              t15 = <span>Sold by:</span>;
              $[29] = t15;
            } else {
              t15 = $[29];
            }
            let t16;
            if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
              t16 = <SelectTrigger className="h-6 w-auto min-w-[100px] px-2 text-body"><SelectValue placeholder="Unassigned" /></SelectTrigger>;
              $[30] = t16;
            } else {
              t16 = $[30];
            }
            let t17;
            if ($[31] !== renderMenuItems || $[32] !== tempProviderId) {
              t17 = <SelectContent>{renderMenuItems(tempProviderId)}</SelectContent>;
              $[31] = renderMenuItems;
              $[32] = tempProviderId;
              $[33] = t17;
            } else {
              t17 = $[33];
            }
            t10 = <span className="inline-flex items-center gap-0.5">{t15}<Select value={tempProviderId} onValueChange={newProviderId_0 => {
                if (editingInfo) {
                  handleProviderChange(newProviderId_0, editingInfo.id);
                }
              }}>{t16}{t17}</Select></span>;
            break bb0;
          }
          let t14;
          if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
            t14 = <span>Sold by:</span>;
            $[34] = t14;
          } else {
            t14 = $[34];
          }
          let t15;
          if ($[35] !== handleInlineEdit || $[36] !== readonly) {
            t15 = !readonly && <Button variant="ghost" size="sm" onClick={handleInlineEdit} icon={<FiEdit className="h-3.5 w-3.5 text-foreground-secondary" />} className="h-5 w-5 p-0 hover:bg-muted" />;
            $[35] = handleInlineEdit;
            $[36] = readonly;
            $[37] = t15;
          } else {
            t15 = $[37];
          }
          let t16;
          if ($[38] !== content || $[39] !== t15) {
            t16 = <span className="inline-flex items-center gap-0.5">{t14}{t15}{content}</span>;
            $[38] = content;
            $[39] = t15;
            $[40] = t16;
          } else {
            t16 = $[40];
          }
          t10 = t16;
          break bb0;
        }
        t10 = content;
        break bb0;
      }
      t8 = "space-y-2";
      t9 = soldByProviderInfo.map(info_0 => {
        const provider_1 = info_0.soldByProviderId ? providerIdProviderMap.get(info_0.soldByProviderId) : undefined;
        const isEditing = editingId === info_0.id;
        return <div key={`item-${info_0.id}`} className="flex items-center gap-1"><div className="flex items-center gap-0.5"><span>Sold by</span>{!readonly && !isEditing && <Button variant="ghost" size="sm" onClick={() => handleEdit(info_0.id, info_0.soldByProviderId)} icon={<FiEdit2 className="h-3 w-3" />} className="h-6 w-6 p-0" />}</div>{isEditing ? <Select value={tempProviderId} onValueChange={newProviderId_1 => {
            handleProviderChange(newProviderId_1, info_0.id);
          }}><SelectTrigger className="h-6 w-auto min-w-[100px] px-2 text-body"><SelectValue placeholder="Unassigned" /></SelectTrigger><SelectContent>{renderMenuItems(tempProviderId)}</SelectContent></Select> : <div>{provider_1 ? formatStaffName(provider_1) : <span className="text-foreground-muted">Unassigned</span>}</div>}</div>;
      });
    }
    $[9] = chargeMutations.updateSoldByProvider;
    $[10] = editingId;
    $[11] = inline;
    $[12] = isInlineEditing;
    $[13] = optimisticItems;
    $[14] = providerIdProviderMap;
    $[15] = readonly;
    $[16] = renderMenuItems;
    $[17] = t7;
    $[18] = tempProviderId;
    $[19] = t10;
    $[20] = t8;
    $[21] = t9;
  } else {
    t10 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[41] !== t8 || $[42] !== t9) {
    t11 = <div className={t8}>{t9}</div>;
    $[41] = t8;
    $[42] = t9;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  return t11;
}
function _temp3(item) {
  return {
    id: item.id,
    name: item.item?.name || item.name || "Custom Item",
    soldByProviderId: item.soldByProviderId
  };
}
function _temp2(i) {
  return typeof i.id === "string" && i.id.length > 0;
}
function _temp(provider) {
  return <SelectItem key={provider.id} value={provider.id}>{formatStaffName(provider)}</SelectItem>;
}